<template>
  <a-col :span="24">
    <a-card title="Assigned Interim Reviewers">
    <a-row :gutter="10">
      <a-col
        :sm="{span:24}" :md="{span:24}" :lg="{span:12}" :xl="{span:8}" :xxl="{span:6}"
        v-for="(review, userId) in interimReviewersObj"
        :key="userId"
      >
        <a-card :title="review.reviewer_name" style="margin-bottom: 10px;">
          <template #extra>
            <div class="assessment-status" hoverable>
              <a-tag color="red" v-if="review.status === 'assigned'">
                <router-link
                  :to="{
                    name: 'assessment-details',
                    params: {
                      assessmentId: review.assessment_id,
                    },
                  }"
                >
                  Assigned
                </router-link>
              </a-tag>

              <a-tag color="cyan" v-if="review.status === 'in_progress'">
                <router-link
                  :to="{
                    name: 'assessment-details',
                    params: {
                      assessmentId: review.assessment_id,
                    },
                  }"
                >
                  In-progress
                </router-link>
              </a-tag>

              <a-tag color="green" v-if="review.status === 'completed'">
                <router-link
                  :to="{
                    name: 'assessment-details',
                    params: {
                      assessmentId: review.assessment_id,
                    },
                  }"
                  >Completed
                </router-link>
              </a-tag>
            </div>
          </template>
          <div class="review-wrapper reviewers-section">
            <div class="reviewer-name">
              <label v-html="'Assigned Reviewer'" />
              <router-link
                :to="{
                  name: 'user-profile',
                  params: {
                    userId: userId,
                  },
                }"
              >
                <span v-html="review.reviewer_name"></span>
              </router-link>
            </div>
            <div class="assigned-date">
              <label>Assigned Date:</label>
              <span v-if="review.assigned_date !== undefined">{{
                review.assigned_date | formatDate
              }}</span>
              <span v-else>---</span>
            </div>
            <div class="commencement-date">
              <label> Commencement Date:</label>
              <span v-if="review.commencement_date !== undefined">{{
                review.commencement_date | formatDate
              }}</span>
              <span v-else>---</span>
            </div>
            <div class="completion-date">
              <label>Completion Date:</label>
              <span v-if="review.completed_date !== undefined">{{
                review.completed_date | formatDate
              }}</span>
              <span v-else>---</span>
            </div>
          </div>
        </a-card>
      </a-col>
    </a-row>
    </a-card>
  </a-col>
</template>
<script>
import { mapGetters } from "vuex";

export default {
  name: "assigned-interim-reviewers-list",
  props: ["courseDetails"],
  computed: {
    ...mapGetters("courses", {
      interimReviewersObj: "interimReviewerObj",
    }),
  },
};
</script>
